Namespace 'Settings.Models.Topics.LinkedIn'

class Settings.Models.Topics.LinkedIn.LinkedInOrganizations extends Backbone.Model
  urlRoot: '/keepcon/topics/linkedin/organizations'

  defaults:
    urn: '',
    name: ''


Namespace 'Settings.Collections.Topics.LinkedIn'

class Settings.Collections.Topics.LinkedIn.LinkedInOrganizations extends Backbone.Collection
  url: '/keepcon/topics/linkedin/organizations'
  model: Settings.Models.Topics.LinkedIn.LinkedInOrganizations

  initialize: (social_account_id) ->
    @social_account_id = social_account_id

  organizations: ->
    @models.map((model) -> {urn: model.get('urn'), name: model.get('name')})

  fetchOrganizations: ->
    @fetch({
      data: {social_account_id: @social_account_id}
      reset: true
    })
